module.exports = __webpack_public_path__ + "img/spacing-example-simple.457074f1.png";